import { Component, Injector, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';

@Component({
  selector: 'app-select-good-dialog',
  templateUrl: './select-good-dialog.component.html',
  styleUrls: ['./select-good-dialog.component.scss']
})
export class SelectGoodDialogComponent  extends BaseFormComponentComponent implements OnInit {

  rows: any[] = [];
  selected: any;
  operation: string;


  constructor( protected injector: Injector, public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    super(injector);
  }

  ngOnInit(): void {
    this.rows = this.config.data.items || [];
    this.operation = this.config.data.operation || null;
  }

  choose(row: any) {
    this.ref.close(row);
  }
}

